import { render, staticRenderFns } from "./AmendDetails.vue?vue&type=template&id=3a472e7c&scoped=true&"
import script from "./AmendDetails.vue?vue&type=script&lang=js&"
export * from "./AmendDetails.vue?vue&type=script&lang=js&"
import style0 from "./AmendDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AmendDetails.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AmendDetails.vue?vue&type=style&index=2&id=3a472e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a472e7c",
  null
  
)

export default component.exports